<template>
  <el-popover
    :placement="placement"
    :title="title"
    :width="width"
    trigger="click"
    :disabled="disabled"
    v-if="popover"
  >
    <template #reference>
      <el-input :value="modelValue?.address" readonly :disabled="disabled" :placeholder="placeholder" suffix-icon="ArrowRight" />
    </template>
    <template #default>
      <iframe
        :id="iframeId"
        width="100%"
        :height="height"
        frameborder="0"
        :src="locationUrl"
      />
    </template>
  </el-popover>
</template>

<script lang="ts" setup>
import type { SnakeCaseAddressInfo } from './types'
import { computed } from 'vue'
import { jsonp } from 'vue-jsonp'
import { mapKey } from '@/utils'

const props = withDefaults(defineProps<{
  modelValue?: SnakeCaseAddressInfo
  placeholder?: string
  width?: number | string
  height?: string
  placement?: 'top' | 'right' | 'bottom' | 'left'
  title?: string
  popover?: boolean
  showMap?: boolean
  iframeId?: string
  disabled?: boolean
}>(), {
  placeholder: '请选择地址',
  width: 400,
  height: '600px',
  placement: 'right',
  title: '选择地址',
  popover: true,
  showMap: true,
  iframeId: 'mapPage',
  disabled: false,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: SnakeCaseAddressInfo): void
}>()

const locationUrl = computed(() => {
  const { latitude = 39.916527, longitude = 116.397128 } = props.modelValue || {}
  return `https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=${mapKey}&referer=myapp&coord=${latitude},${longitude}`
})

// 监听地图选点消息
window.addEventListener('message', (event) => {
  const loc = event.data
  if (loc && loc.module === 'locationPicker') {
    console.log('event', event)
    // 使用jsonp获取详细地址信息
    const url = 'https://apis.map.qq.com/ws/geocoder/v1/'
    const data = {
      location: `${loc.latlng.lat},${loc.latlng.lng}`,
      key: mapKey,
      get_poi: 1,
      output: 'jsonp',
    }

    jsonp(url, data)
      .then((res: any) => {
        if (res.status === 0) {
          emit('update:modelValue', {
            detail_address: `${loc.poiaddress} ${loc.poiname}`,
            address: `${loc.poiaddress} ${loc.poiname}`,
            latitude: loc.latlng.lat,
            longitude: loc.latlng.lng,
            ad_info: res.result.ad_info,
            address_component: res.result.address_component,
          })
        }
      })
      .catch((err) => {
        console.error('获取地理位置错误:', err)
      })
  }
}, false)
</script>
